export default {
  visitList: state => state.visitList,
  visitDetail: state => state.visitDetail,
  visitTypeList: state => state.visitTypeList,
  visitTeams: state => state.visitTeams,
  visitCustomerDataList: state => state.visitCustomerDataList,
  visitMedicalCustomerDataList: state => state.visitMedicalCustomerDataList,
  visitCustomerSalesmanDataList: state => state.visitCustomerSalesmanDataList,
  visitCustomerConvertDataList: state => state.visitCustomerConvertDataList,
  visitBusinessDataList: state => state.visitBusinessDataList,
  visitBusinessConvertDataList: state => state.visitBusinessConvertDataList,
  visitCluesDataList: state => state.visitCluesDataList,
};
